import { Injectable } from '@angular/core';
import { MyStuffService } from './my-stuff.service';
import { LoaderService } from './loader.service';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { PinService } from './pin.service';
import { PropertyService } from './property.service';
import { RetailerService } from './retailer.service';

@Injectable()
export class RemovedItemsService {

  constructor(public myStuffService : MyStuffService, public loaderService : LoaderService,
              public pinService : PinService,public propertyService : PropertyService,
              public retailerService : RetailerService) { }

  allRemovedItemsElement: any;
  allRemovedItemsInputElement: any;
  GOOGLE_CLIENT_ID = environment.APP.GOOGLE_CLIENT_ID;

  pinsContainerElement: any;
  pinsInputElement: any;

  propertiesContainerElement: any;
  propertiesInputElement: any;

  retailersContainerElement: any;
  retailersInputElement: any;

  fetchAllRemovedItemsSource = new BehaviorSubject<boolean>(false);
  fetchAllRemovedItemsStream = this.fetchAllRemovedItemsSource.asObservable();

  fetchRemovedPinsSource = new BehaviorSubject<boolean>(false);
  fetchRemovedPinsStream = this.fetchRemovedPinsSource.asObservable();

  fetchRemovedPropertiesSource = new BehaviorSubject<boolean>(false);
  fetchRemovedPropertiesStream = this.fetchRemovedPropertiesSource.asObservable();

  fetchRemovedRetailersSource = new BehaviorSubject<boolean>(false);
  fetchRemovedRetailersStream = this.fetchRemovedRetailersSource.asObservable();

  //ALL REMOVED ITEMS

  searchAllRemovedItems() {
    this.myStuffService.resetAllRemovedItemsPagination();
    this.fetchAllRemovedItems();
  }

  allRemovedItemsAddInputEventObservable() {
    this.allRemovedItemsInputElement = document.getElementById('all-removed-items-input');
    if(this.allRemovedItemsInputElement) {
      Observable.fromEvent(this.allRemovedItemsInputElement, 'input')
      .debounceTime(500)
      .subscribe((event) => {
        this.searchAllRemovedItems();
      });
    }
  }

  fetchAllRemovedItems() {
    if(!this.myStuffService.allRemovedItemsFetching && !this.myStuffService.allRemovedItemsFetched) {
      this.loaderService.addGreyLoaderClass();
      this.myStuffService.allRemovedItemsFetching = true;
      this.myStuffService.getAllRemovedItems().subscribe((response: any) => {
        this.myStuffService.allRemovedItemsFetching = false;
        for(var i = 0; i < response.length; i++) {
          if(response[i].itemType === 'property') {
            (response[i].geom)? this.processProperty(response[i]) : this.myStuffService.allRemovedItems.push(response[i]);
          } else {
            this.myStuffService.allRemovedItems.push(response[i]);
          }
          !this.allRemovedItemsInputElement && this.allRemovedItemsAddInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
      }, (error)=>{
        this.myStuffService.allRemovedItemsFetching = false;
        throw(error);
      });
    }
  }

  processProperty(response) {
    let w = (<any>window);
    if(response.geom.type === 'Point') {
      response.position = new w.google.maps.LatLng(response.geom.coordinates[1],response.geom.coordinates[0]);
    } else if(response.geom.type === 'MultiPolygon') {
      response.polygon = new w.google.maps.Polygon({
        path: w.getPolygonPaths(response.geom.coordinates[0][0]),
      });
      response.position = w.getPolygonCenter(response.polygon);
    }
    this.myStuffService.allRemovedItems.push(response);
    var globalId = response.globalId ? response.globalId : null;
    this.myStuffService.allRemovedItems[this.myStuffService.allRemovedItems.length-1].streetViewImage = environment.APP.API_URL + '/image-service/property/streetview/'+ response.id
      +'/image?globalId=' + globalId + '&width=119&height=88&defaultImg=true';

  }

  //REMOVED PINS
  searchPins() {
    this.pinService.resetDeletedPagination();
    this.fetchDeletedPins();
  }

  fetchDeletedPins() {
    if(!this.pinService.deletedPinsfetching && !this.pinService.allDeletedFetched) {
      this.loaderService.addGreyLoaderClass();
      this.pinService.deletedPinsfetching = true;
      this.pinService.getMapDeletedPins().subscribe((data: any) => {
        this.pinService.deletedPinsfetching = false;
        for(var i = 0; i < data.length; i++) {
          this.pinService.deletedPins.push(data[i]);
          !this.pinsInputElement && this.removedPinsAddInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
      }, (error)=>{
        this.pinService.deletedPinsfetching = false;
        throw(error);
      });
    }
  }

  removedPinsAddInputEventObservable() {
    this.pinsInputElement = document.getElementById('removed-pins-search-input');
    if(this.pinsInputElement) {
      Observable.fromEvent(this.pinsInputElement, 'input')
      .debounceTime(500)
      .subscribe((event) => {
        this.searchPins();
      });
    }
  }

  //REMOVED PROPERTIES
  searchDeletedProperties() {
    this.propertyService.resetDeletedPagination();
    this.fetchDeletedProperties();
  }

  fetchDeletedProperties() {
    if(!this.propertyService.allDeletedFetched && !this.propertyService.isDeletedFetching) {
      let w = (<any>window);
      this.propertyService.isDeletedFetching = true;
      this.loaderService.addGreyLoaderClass();
      this.propertyService.getMyDeletedProperties().subscribe((response)=> {
        this.propertyService.isDeletedFetching = false;
        for(let i = 0; i < response.length; i++) {
          if(response[i].geom.type === 'Point') {
            response[i].position = new w.google.maps.LatLng(response[i].geom.coordinates[1],response[i].geom.coordinates[0]);
          } else if(response[i].geom.type === 'MultiPolygon') {
            response[i].polygon = new w.google.maps.Polygon({
              path: w.getPolygonPaths(response[i].geom.coordinates[0][0]),
            });
            response[i].position = w.getPolygonCenter(response[i].polygon);
          }
          this.propertyService.myDeletedProperties.push(response[i]);
          var globalId = response[i].globalId ? response[i].globalId : null;
          this.propertyService.myDeletedProperties[this.propertyService.myDeletedProperties.length-1].streetViewImage = environment.APP.API_URL + '/image-service/property/streetview/'+ response[i].id
            +'/image?globalId=' + globalId + '&width=119&height=88&defaultImg=true';

          !this.propertiesInputElement && this.removedPropertiesAddInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        w.Events.publish('detectChanges');
      },(error)=>{
        this.propertyService.isDeletedFetching = false;
        this.loaderService.removeGreyLoaderClass();
        throw(error);
      });
    }
  }

  removedPropertiesAddInputEventObservable() {
    this.propertiesInputElement = document.getElementById('removed-properties-search-input');
    if(this.propertiesInputElement) {
      Observable.fromEvent(this.propertiesInputElement, 'input')
        .debounceTime(500)
        .subscribe((event) => {
          this.searchDeletedProperties();
        });
    }
  }

  //REMOVED RETAILERS
  searchDeletedRetailers() {
    this.retailerService.resetDeletedPagination();
    this.fetchDeletedRetailers();
  }

  fetchDeletedRetailers() {
    if(!this.retailerService.allDeletedFetched && !this.retailerService.isDeletedFetching) {
      this.retailerService.isDeletedFetching = true;
      this.loaderService.addGreyLoaderClass();
      this.retailerService.getMyDeletedRetailers().subscribe((response)=> {
        this.retailerService.isDeletedFetching = false;
        for(let i = 0; i < response.length; i++) {
          this.retailerService.myDeletedRetailers.push(response[i]);
          !this.retailersInputElement && this.removedRetailersAddInputEventObservable();
        }
        this.loaderService.removeGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
      },(error)=>{
        this.retailerService.isDeletedFetching = false;
        this.loaderService.removeGreyLoaderClass();
        throw(error);
      });
    }
  }

  removedRetailersAddInputEventObservable() {
    this.retailersInputElement = document.getElementById('removed-retailers-search-input');
    if(this.retailersInputElement) {
      Observable.fromEvent(this.retailersInputElement, 'input')
      .debounceTime(500)
      .subscribe((event)=> {
        this.searchDeletedRetailers();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/removed-items.service.ts